// extracted by mini-css-extract-plugin
module.exports = {"canPower":"canPower_canPower__H0qKE"};